import React from "react";
import { DDUIcon } from "Components/Icons";
import DirectDepositUpdateButton from "Components/Pages/DirectDepositUpdate/DirectDepositUpdateButton/DirectDepositUpdateButton";
import useDirectDepositFiles from "Components/Pages/DirectDepositUpdate/Hooks/useDirectDepositFiles";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import CalloutCard, { CalloutCardProps } from "../CalloutCard/CalloutCard";
import SupplementaryInfo from "../CalloutCard/SupplementaryInfo/SupplementaryInfo";

const DDUCalloutCard = () => {
  const { pendingCount, refetch, loading } = useDirectDepositFiles();
  const updatesText = `${pendingCount} Update${pendingCount !== 1 ? "s" : ""}`;

  const props: CalloutCardProps = {
    loading,
    midInfo: (
      <SupplementaryInfo
        pendingCount={pendingCount}
        text={updatesText}
      />
    ),
    button: (
      <DirectDepositUpdateButton
        pendingCount={pendingCount}
        refetch={refetch}
      />
    ),
    title: "Direct Deposit",
    description: "Download direct deposit updates",
    arrowNavigationHref: InternalRoutes.directDeposit,
    icon: <DDUIcon />,
  };

  return <CalloutCard {...props} />;
};

export default DDUCalloutCard;
